import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateItem, removeItem } from '../../store';
import './Cart.css';
import { useNavigate } from 'react-router-dom';

import Modal from '../../components/Modal/Modal';

function Cart() {
    const guitars = useSelector((state) => state.guitars); 
    const cart = useSelector((state) => state.cart);       // Array of cart items
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOrderClick = () => {
        setIsModalOpen(true);
    };

    const handleConfirm = () => {
        alert(`주문완료!!!!!!!!\n주문금액: ${totalSum.toLocaleString()}`);
        setIsModalOpen(false); // 모달 닫기
    };

    const handleCancel = () => {
        setIsModalOpen(false); // 모달 닫기
    };

    // Toggle the "checked" state of an item
    const handleCheckboxChange = (id, currentChecked) => {
        dispatch(
            updateItem({
                id,
                changes: { checked: !currentChecked }, // 현재 체크 상태 반대로 변경
            })
        );
    };

    // Update quantity and (optionally) total
    const handleQuantityChange = (id, value) => {
        const quantity = parseInt(value, 10) || 1; // 입력값이 비어있으면 기본값 1
        const guitarPrice = guitars[id]?.price ?? 0; // 현재 아이템의 가격
        dispatch(
            updateItem({
                id,
                changes: {
                    quantity, // 변경된 수량 업데이트
                    total: guitarPrice * quantity, // 총합 업데이트
                },
            })
        );
    };

    // Remove item from cart
    const handleRemove = (id) => {
        dispatch(removeItem(id)); // 아이템 제거
    };

    // Calculate sum of checked items
    const totalSum = cart.reduce((acc, item) => {
        if (item.checked) {
            const guitarPrice = guitars[item.id]?.price ?? 0; // 체크된 아이템 가격 합산
            return acc + guitarPrice * item.quantity; // 체크된 아이템의 총합 반환
        }
        return acc; // 체크되지 않은 아이템은 제외
    }, 0);

    return (
        <div className='cart common-padding'>
            <table className="cart-table">
                <thead className="cart-table__head">
                    <tr className="cart-table__head-row">
                        <th className="cart-table__head-cell">Select</th>
                        <th className="cart-table__head-cell">Image</th>
                        <th className="cart-table__head-cell">Name</th>
                        <th className="cart-table__head-cell">Price</th>
                        <th className="cart-table__head-cell">Quantity</th>
                        <th className="cart-table__head-cell">Total</th>
                        <th className="cart-table__head-cell">Remove</th>
                    </tr>
                </thead>

                <tbody className="cart-table__body">
                    {cart.map((item) => {
                        const guitarData = guitars[item.id];
                        if (!guitarData) return null; // 아이템 데이터가 없으면 스킵

                        const { id, quantity, checked, total } = item; // 상태에서 가져온 아이템 정보
                        const { title, price } = guitarData; // Guitar 데이터에서 가져온 정보

                        return (
                            <tr className="cart-table__body-row" key={id}>
                                <td className="cart-table__body-cell cart-table__body-cell--checkbox">
                                    <input
                                        type="checkbox"
                                        checked={checked} // Redux 상태에서 가져온 checked 값
                                        onChange={() => handleCheckboxChange(id, checked)} // 체크박스 상태 변경
                                        className="cart-table__checkbox"
                                    />
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--image">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/guitar_detail/guitar-${id}-${title}.jpg`}
                                        alt={title}
                                        height="50"
                                        className="cart-table__image"
                                        onClick={()=>{navigate(`/shop/${id}`)}}
                                    />
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--title">
                                    <p onClick={() => { navigate(`/shop/${id}`) }}>{title}</p>
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--price">
                                    {price.toLocaleString()} {/* 상품 가격 */}
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--quantity">
                                    <input
                                        type="number"
                                        min="1"
                                        value={quantity} // 현재 수량 값
                                        onChange={(e) => handleQuantityChange(id, e.target.value)} // 수량 변경
                                        className="cart-table__quantity-input"
                                    />
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--total">
                                    {(total ?? (price * quantity)).toLocaleString()} {/* 총합 */}
                                </td>
                                <td className="cart-table__body-cell cart-table__body-cell--remove">
                                    <button
                                        onClick={() => handleRemove(id)} // 아이템 제거
                                        className="cart-table__remove-button"
                                    >
                                        X
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="cart-footer">
                <span className="cart-total">Total :</span>
                <span className='cart-total'>{totalSum.toLocaleString()}</span> {/* 체크된 아이템 총합 */}
                <button 
                    className={`order-button ${totalSum === 0 ? 'order-button--disabled' : ''}`} // 총합이 0이면 비활성화
                    onClick={handleOrderClick} 
                    disabled={totalSum === 0}>주문하기</button>

                {isModalOpen && (
                    <Modal
                        message={
                            <>
                                주문하시겠습니까?<br />
                                주문금액: {totalSum.toLocaleString()}
                            </>
                        }
                        onConfirm={handleConfirm}
                        onCancel={handleCancel}
                    />
                )}
            </div>
        </div>
    );
}

export default Cart;
